import React from 'react'

import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService'
import UnknownProductDetail from '@shared/unknown_products/UnknownProductDetail'
import { useLoaderData } from 'react-router-dom'

import { unknownProductService } from '@services/operator/unknownProductService'

export default function OperatorUnknownProductShow() {
  const unknownProduct = useLoaderData()
  // 使用 hook 版本的 productService，會自動從 MerchantContext 注入 merchant_id
  const productService = useOperatorProductService()

  return (
    <UnknownProductDetail
      unknownProduct={unknownProduct}
      role="operator"
      unknownProductService={unknownProductService}
      productService={productService}
    />
  )
}
